import React, {PureComponent} from "react"
import {translate} from "react-i18next"
import PropTypes from "prop-types"

import styles from "../styles.css"

class DefaultLangSwitch extends PureComponent {
  static propTypes = {
    languages: PropTypes.object.isRequired,
    defaultLang: PropTypes.string.isRequired,
    onSubmit: PropTypes.func,
    updating: PropTypes.bool,
  }

  static defaultProps = {
    onSubmit: (lang) => console.log(lang),
    updating: false,
  }

  state = {
    edit: false,
    changed: false,
    selectedLanguage: "",
  }

  constructor(props) {
    super(props)

    this.switchEditMode = this.switchEditMode.bind(this)
    this.setLanguage = this.setLanguage.bind(this)
    this.submitLanguage = this.submitLanguage.bind(this)
  }

  getLanguages() {
    const {languages, t} = this.props

    return {"": t("Standard", {context: "lang_switch"}), ...languages}
  }

  setLanguage(lang) {
    this.setState((prevState) => {
      return {
        ...prevState,
        changed: true,
        selectedLanguage: lang,
      }
    })
  }

  submitLanguage() {
    if(this.state.changed && this.state.selectedLanguage !== this.props.defaultLang) {
      this.props.onSubmit(this.state.selectedLanguage)
    }

    this.switchEditMode()
  }

  renderSelect() {
    const {defaultLang} = this.props
    const languages = this.getLanguages()

    return (
      <select defaultValue={defaultLang} onChange={(e) => this.setLanguage(e.target.value)}>
        {Object.keys(languages).map((lang) => {
          return (
            <option key={lang} value={lang}>{languages[lang]}</option>
          )
        })}
      </select>
    )
  }

  switchEditMode() {
    this.setState((prevState) => {
      return {
        ...prevState,
        edit: !prevState.edit,
      }
    })
  }

  render() {
    const {defaultLang, updating} = this.props

    if(updating) {
      return <div className={styles.DefaultLangSwitch}><span className="loading">...</span></div>
    }

    return <div className={styles.DefaultLangSwitch}>
      {this.state.edit ? (
        <span>
          {this.renderSelect()}
          <button className="button accept-button" onClick={this.submitLanguage}><i className="icon-quiz-feedback-right"></i></button>
          <button className="button deny-button" onClick={this.switchEditMode}><i className="icon-quiz-feedback-wrong"></i></button>
        </span>
      ) : (
        <span>
          <span>{this.getLanguages()[defaultLang]}</span>
          <button className="button edit-button" onClick={this.switchEditMode}><i className="icon-edit"></i></button>
        </span>
      )}
    </div>
  }
}

export default translate()(DefaultLangSwitch)



// WEBPACK FOOTER //
// ./src/containers/UserProfile/UserInformation/defaultLangSwitch.js